import { getUploadingFileData, uploadFileToAWS } from "../service";

export const uploadFileIfNeeded = async (file, basePath, progressCallback = null) => {
  if (!file?.type) return file;

  const timestamp = new Date().getTime();
  const {
    data: { url, finalName }
  } = await getUploadingFileData({
    name: `${basePath}/${timestamp}-${file.name}`,
    type: file.type
  });

  await uploadFileToAWS(url, file, file.type, progressCallback);
  return finalName;
};

export const convertRGBAObjectToString = (rgbObject) => {
  if (rgbObject?.rgb) {
    return `rgba(${rgbObject?.rgb?.r}, ${rgbObject?.rgb?.g}, ${rgbObject?.rgb?.b}, ${rgbObject?.rgb?.a})`;
  }
  return rgbObject;
};
